import { useEffect } from "react";
import { SITE } from "../site/content";

export default function Seo({ title, description, path = "/" }) {
  useEffect(() => {
    const full = `${title} | ${SITE.name}`;
    document.title = full;
    const set = (selector, value) => {
      const el = document.head.querySelector(selector);
      if (el) el.setAttribute("content", value);
    };
    set('meta[name="description"]', description);
    set('meta[property="og:title"]', full);
    set('meta[property="og:description"]', description);
    set('meta[property="og:url"]', `${SITE.domain}${path}`);
    const canonical = document.head.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute("href", `${SITE.domain}${path}`);
  }, [title, description, path]);
  return null;
}
